export function clampIndex(index: number, length: number): number {
    if (length === 0) return 0; // no items
    if (index < 0) return 0;
    if (index >= length) return length - 1;
    return index;
}
